exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container-vmo0j {\n  position: absolute;\n  margin-top: 15px;\n}", ""]);

// Exports
exports.locals = {
	"container": "container-vmo0j"
};